/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";
import getColor from "@insite/mobius/utilities/getColor";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

columnsStyles.container = {
    gap: 0,
};

columnsStyles.rightColumnGridItem = {
    width: [12, 12, 8, 9, 9],
    css: css`
        flex-direction: column;

        ${screen("gte", "md")} {
            padding-left: 4px;
        }
    `,
};

columnsStyles.leftColumnGridItem = {
    width: [12, 12, 4, 3, 3],
    css: css`
        ${screen("gte", "md")} {
            padding-right: 30px;
        }

        ${screen("lt", "md")} {
            &&& {
                margin-bottom: 40px;
            }
        }
    `,
};

(columnsStyles as any).productListRightSectionContainer = {
    gap: 0,
};

(columnsStyles as any).productListCountGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        padding-bottom: 15px;
        border-bottom: 1px solid ${getColor("common.ui12")};
    `,
};

(columnsStyles as any).productListViewGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        align-items: flex-end;
        padding-bottom: 15px;
        border-bottom: 1px solid ${getColor("common.ui12")};

        ${screen("lt", "md")} {
            display: none;
        }
    `,
};

(columnsStyles as any).productListGridItem = {
    width: 12,
    css: css`
        padding-top: 15px;
    `,
};
